import React, { FunctionComponent, useEffect, useState } from "react";
import axios from "axios";
import { showSnackbarAction } from "../../Redux/actions";
import { themeColors } from "../../Components/theme";
import { connect, useDispatch } from "react-redux";
import { url } from "../../Values/constants";
import "../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme, TextField, Typography } from "@mui/material";
import styles from "../AddUsers/AddUsers.module.css";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import Loading from "../../Components/Loading/Loading";
import InputTextValue from "../../Components/TextInput/InputTextValue";

interface MyFormValues {
  [key: string]: any;
}

const initialFormValues: MyFormValues = {
  booking_id: "Booking Id",
  added_by: "Added By",
  added_time: "Added Time",
  modified_by: "Modified By",
  modified_time: "Modified Time",
  date_booking: "Date Booking",
  developer_name: "Developer Name",
  project_name: "Project Name",
  area: "Area",
  unit_no: "Unit Number",
  source_fund: "Source Fund",
  scheme: "Scheme",
  booking_attachment: "Booking Attachment",
  pan_card: "Pan Card",
  area_type: "Area Type",
  Kyc_attachment: "Kyc Attachment",
  employee_details: {
    owner_email: "Owner Email",
    in_active_employe: "In Active Employe",
  },
  applicant_details: {
    applicant: {
      name: "Name",
      address_line1: "Address Line1",
      address_line2: "Address Line2",
      city: "City",
      state: "State",
      country: "Country",
      postal_code: "PinCode",
      phone_number1: "Phone Number1",
      phone_number2: "Phone Number2",
      email: "Email",
      gender: "Gender",
      date_of_birth: "Date of Birth",
      marrital_status: "Marrital Status",
      occupation: "Occupation",
      company_name: "Company Name",
      designation: "Designation",
      net_monthly_income: "Net Monthly Income",
      aadhaar_no: "Aadhaar No",
      pan_no: "Pan No",
    },
    co_applicant: [
      {
        name: "Name",
        address_line1: "Address Line1",
        address_line2: "Address Line2",
        city: "City",
        state: "State",
        country: "Country",
        postal_code: "PinCode",
        phone_number1: "Phone Number1",
        phone_number2: "Phone Number2",
        email: "Email",
        gender: "Gender",
        date_of_birth: "Date of Birth",
        marrital_status: "Marrital Status",
        occupation: "Occupation",
        company_name: "Company Name",
        designation: "Designation",
        net_monthly_income: "Net Monthly Income",
        aadhaar_no: "Aadhaar No",
        pan_no: "Pan No",
      },
    ],
  },
  property_details_BSP: {
    tower_block: "Tower Block",
    area: "Area",
    measure: "Measure",
    floor: "Floor",
    payment_plan: "Payment Plan",
    bsp: "BSP",
    bsp_discounting_type: "BSP Discounting Type",
    bsp_discount_amount: "BSP Discount Amount",
    bsp_discount: "BSP Discount",
    net_bsp_after_discount: "Net BSP After Discount",
  },
  additional_charges: {
    a: "A",
    b: "B",
    c: "C",
    d: "D",
    e: "E",
    f: "F",
    g: "G",
    h: "H",
    i: "I",
    a_amount: "A Amount",
    b_amount: "B Amount",
    c_amount: "C Amount",
    d_amount: "D Amount",
    e_amount: "E Amount",
    f_amount: "F Amount",
    g_amount: "G Amount",
    h_amount: "H Amount",
    i_amount: "I Amount",
    total_additional_charges: "Total Additional Charges",
  },
  consolidated_costing: {
    net_bsp_area: "Net BSP Area",
    total_additional_charges: "Total Additional Charges",
    gross_property_cost_applicant: "Gross Property Cost Applicant",
    gst_amount: "GST Amount",
    gst: "GST",
    net_property_cost_applicant: "NET Property Cost Applicant",
    minimum_booking_amount: "Minimum Booking Amount",
  },
  payment_plan: [
    {
      payment_instalments: "Payment Instalments",
      payment: "Payment",
      payment_amount: "Payment Amount",
      payment_date: "Payment Date",
      payment_reference: "Payment Reference",
      payment_source: "Payment Source",
      bank_name: "Bank Name",
      payment_receiving_proof: "Payment Receiving Proof",
      payment_clearance_proof: "Payment Clearance Proof",
      payment__proof: "Payment Proof",
      Payment_Status: "Payment Status",
    },
  ],
  source_of_fund: {
    funding_source: "Funding Source",
    Occupation: "Occupation",
    gross_monthly_income: "GROSS Monthly Income",
    annual_bonus_incentive: "Annual Bonus Incentive",
    rental_income: "Rntal Income",
    existing_EMI: "Existing EMI",
  },
  attachments: {
    developer_receiving: "Developer Receiving",
    BE_form: "BE Form",
    approvals: "Approvals",
    remarks: "Remarks",
  },
};

type props = {
  user: any;
  theme: any;
  history: any;
};
const BookingFormIndustries: FunctionComponent<props> = ({
  user,
  theme,
  history
}) => {
  const dispatcher = useDispatch();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const [formValues, setFormValues] = useState<MyFormValues>(initialFormValues);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [load, setLoad] = useState(false);
  const [selectedIndustries, setSelectedIndustries] = useState("");

  const handleInputChange = (path: string, value: any) => {
    // Parse path like "a.b[0].c" into tokens: ['a','b',0,'c']
    const tokens = path
      .split(".")
      .flatMap((seg) => {
        const matches = seg.match(/([^\[\]]+)|\[(\d+)\]/g);
        return matches
          ? matches.map((m) => (m.startsWith("[") ? Number(m.replace(/\[|\]/g, "")) : m))
          : [seg];
      });

    setFormValues((prev) => {
      // deep clone to avoid mutating state
      const updated: any = JSON.parse(JSON.stringify(prev));
      let cur: any = updated;
      for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i];
        const nextToken = tokens[i + 1];
        if (i === tokens.length - 1) {
          // set value
          cur[token as any] = value;
        } else {
          // ensure the path exists
          if (typeof nextToken === "number") {
            if (!Array.isArray(cur[token as any])) cur[token as any] = [];
          } else {
            if (cur[token as any] == null || typeof cur[token as any] !== "object")
              cur[token as any] = {};
          }
          cur = cur[token as any];
        }
      }
      return updated;
    });
  };
  const capitalizeKey = (key: string) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
  };

  const renderFormFields = (data: any, prefix: string = "") => {
    // Use MUI Grid for responsive layout
    return (
      <Grid container spacing={2}>
        {Object.keys(data).map((key) => {
          const fullPath = prefix ? `${prefix}.${key}` : key;
          const value = data[key];
          const displayKey = capitalizeKey(key);
          // Nested object (render as section)
          if (typeof value === "object" && !Array.isArray(value)) {
            return (
              <Grid item xs={12} key={fullPath} style={{ display: "flex", justifyContent: "center" }}>
                <fieldset style={{ border: "none", padding: 0, width: "100%" }}>
                  <legend style={{
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-medium)", marginBottom: 10
                  }}>
                    {displayKey}
                  </legend>
                  {renderFormFields(value, fullPath)}
                </fieldset>
              </Grid>
            );
          }
          // Array of items (render each item as its own block)
          if (Array.isArray(value)) {
            return (
              <Grid item xs={12} key={fullPath} style={{ display: "flex", justifyContent: "center" }}>
                <fieldset style={{ border: "none", padding: 0, width: "100%" }}>
                  <legend style={{
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-medium)", marginBottom: 20
                  }}>
                    {displayKey}
                  </legend>
                  {value.map((item: any, index: number) => (
                    <fieldset key={`${fullPath}[${index}]`} style={{ border: "none", padding: 0 }}>
                      {renderFormFields(item, `${fullPath}[${index}]`)}
                    </fieldset>
                  ))}
                </fieldset>
              </Grid>
            );
          }
          // Primitive value -> render TextField in grid cell
          return (
            // make inputs full width on small screens and reasonably constrained on larger screens
            <Grid item xs={12} sm={4} key={fullPath} style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%" }}>
                <InputTextValue
                  title={fullPath}
                  value={value}
                  onChange={(e) => handleInputChange(fullPath, e.target.value)}
                />
              </div>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  useEffect(() => {
    const selectedIndustries = localStorage.getItem("selectedIndustries") || "";
    const allIndustries = JSON.parse(localStorage.getItem("allIndustries") || "[]");
    const getSingleInd = allIndustries.filter(
      (obj: any) => obj.industry_id === selectedIndustries
    );
    if (getSingleInd.length > 0) {
      setSelectedIndustries(getSingleInd[0]["industry_name"]);
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const selectedIndustries = localStorage.getItem("selectedIndustries") || "";
      const allIndustries = JSON.parse(localStorage.getItem("allIndustries") || "[]");
      const getSingleInd = allIndustries.filter(
        (obj: any) => obj.industry_id === selectedIndustries
      );
      setSelectedIndustries(getSingleInd[0]["industry_name"]);
      const apiData = {
        industry_id: selectedIndustries,
        industry_name: getSingleInd[0]["industry_name"],
        created_by: user.user_email,
        bookingFrom: formValues,
      };
      const res = await axios.post(url + "/bookings/createFrom", apiData);
      if (res.status == 200) {
        if (res.data === "Booking From Already Exist") {
          dispatcher(showSnackbarAction(res.data, "error"));
        } else {
          dispatcher(showSnackbarAction(res.data, "success"));
        }
        history.replace("/bookingForm");
        setIsSubmitting(false);
      } else {
        dispatcher(showSnackbarAction(res.data, "error"));
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error(error);
      showSnackbarAction("An error occurred", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const cardContainerStyles = {
    backgroundColor: theme
      ? themeColors.cardBackgroundColor
      : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  return (
    <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
      {load && <Loading />}
      <div
        className={`d-flex flex-row w-100 px-4 ${isMobile ? "pt-4" : "pt-2"}`}
      >
        <h5
          style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}

        >
          {selectedIndustries}
        </h5>
      </div>
      <div
        className={`w-100 d-flex flex-column gap-2 ${isMobile ? "px-2" : "px-4"}`}
        style={{
          padding: isMobile ? '0' : '',
          maxWidth: isMobile ? '100vw' : undefined,
          margin: isMobile ? '0' : '0 auto',
          overflowY: 'auto',
          maxHeight: isMobile ? 'calc(100vh - 120px)' : 'calc(100vh - 90px)',
        }}
      >
        <form
          className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
          style={{
            ...cardContainerStyles,
            padding: isMobile ? '12px' : '36px', // reduce padding slightly for very small screens
            boxSizing: 'border-box',
            minHeight: isMobile ? 'auto' : undefined,
            marginBottom: isMobile ? '50px' : 0,
          }}
        >
          <Grid container spacing={isMobile ? 2 : 3} justifyContent="center">
            {/* center the whole dynamic form and constrain its max width on mobile */}
            <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%", maxWidth: isMobile ? 380 : 920 }}>
                {renderFormFields(formValues)}
              </div>
            </Grid>
            {/* Remove submit button from inside form for mobile */}
            {!isMobile && (
              <Grid item xs={12} style={{ marginTop: 12 }}>
                <StyledSubmitButton
                  onClick={(e) => handleSubmit(e)}
                  themeMode={themeMUI.palette.mode}
                >
                  {load ? (
                    <span style={{ display: "flex", justifyContent: "center" }}>
                      <Circles color="#fff" height={20} width={20} />
                    </span>
                  ) : (
                    <>{isSubmitting ? "Saving..." : "Submit"}</>
                  )}
                </StyledSubmitButton>
              </Grid>
            )}
          </Grid>
        </form>
      </div>
      {isMobile && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: "white",
            p: 2,
            borderTop: "1px solid #ddd",
            boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
            zIndex: 100,
          }}
        >
          <StyledSubmitButton
            onClick={(e) => handleSubmit(e)}
            themeMode={themeMUI.palette.mode}
            isMobile={isMobile}
          >
            {load ? (
              <span style={{ display: "flex", justifyContent: "center" }}>
                <Circles color="#fff" height={20} width={20} />
              </span>
            ) : (
              <>{isSubmitting ? "Saving..." : "Submit"}</>
            )}
          </StyledSubmitButton>
        </Box>
      )}
    </div>
  );
};
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
  };
};

export default connect(mapStateToProps)(BookingFormIndustries);
